import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconMapping: React.FC<IconProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.5464 5.98959L18.0108 2.45406C17.6203 2.06353 16.9871 2.06353 16.5966 2.45405L11.6469 7.4038C11.2563 7.79433 11.2563 8.42749 11.6469 8.81802L15.1824 12.3535C15.5729 12.7441 16.2061 12.7441 16.5966 12.3535L21.5464 7.4038C21.9369 7.01328 21.9369 6.38011 21.5464 5.98959Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12.354 15.182L8.81847 11.6464C8.42794 11.2559 7.79478 11.2559 7.40425 11.6464L2.4545 16.5962C2.06398 16.9867 2.06398 17.6199 2.4545 18.0104L5.99004 21.5459C6.38056 21.9365 7.01373 21.9365 7.40425 21.5459L12.354 16.5962C12.7445 16.2057 12.7445 15.5725 12.354 15.182Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M15.5362 8.46448L8.46506 15.5355"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
